import { render, staticRenderFns } from "./buildingList.vue?vue&type=template&id=4f1fc828&scoped=true&"
import script from "./buildingList.vue?vue&type=script&lang=js&"
export * from "./buildingList.vue?vue&type=script&lang=js&"
import style0 from "./buildingList.vue?vue&type=style&index=0&id=4f1fc828&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1fc828",
  null
  
)

export default component.exports